import React from "react";
// State
import { useSelector } from "react-redux";
import { selectMode } from "../app/appSlice";
// Config
import { projectsData } from "../config";
// Icons
import { Icon } from "@iconify/react";
// Components
import { Element } from "react-scroll";
import { Button, Col, Container, Row } from "react-bootstrap";
import Title from "./Title";
import ProjectCard from "./ProjectCard";
import styled from "styled-components";

const StyledSection = styled.section`
  padding: 4rem 0;
  
  .projects-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .project-col {
    margin-bottom: 2rem;
  }
  
  @media (max-width: 768px) {
    padding: 2rem 0;
  }
`;

const Projects = () => {
  const theme = useSelector(selectMode);

  return (
    <Element name={"Project Highlights"} id="projects">
      <StyledSection className="section">
        <Container className="projects-container">
          <Container className="d-flex justify-content-center mb-5">
            <Title size={"h2"} text={"Project Highlights"} />
          </Container>
          <Row xs={1} md={2} lg={3} className="g-4 justify-content-center">
            {projectsData.map((project) => (
              <Col key={project.id} className="project-col">
                <ProjectCard
                  image={project.image}
                  name={project.name}
                  description={project.description}
                  url={project.url}
                  demo={project.demo}
                  technologies={project.technologies}
                  paper={project.paper}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </StyledSection>
    </Element>
  );
};

export default Projects;
